type LoggerType = {
  type: LoggerEnums;
  errorCode?: number;
  errorMessage: string;
};

export enum LoggerEnums {
  EXPECTED = "EXPECTED",
  SYSTEM = "SYSTEM",
}

export const Logger = (_payload: LoggerType) => {
  if (_payload.errorCode === 0) return;

  console.groupCollapsed(
    "%c [CB_LOGGER]               ",
    "background: #479aff; color: white; display: block;"
  );

  if (typeof _payload.errorCode === "undefined") {
    _payload.errorCode = 0;
  }

  console.log(_payload);
  console.groupEnd();
};
